import { render, staticRenderFns } from "./SelectBoxItem.vue?vue&type=template&id=176e5cf2&scoped=true"
import script from "./SelectBoxItem.vue?vue&type=script&lang=ts"
export * from "./SelectBoxItem.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxItem.vue?vue&type=style&index=0&id=176e5cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176e5cf2",
  null
  
)

export default component.exports